import { render, staticRenderFns } from "./FeedbackDialog.vue?vue&type=template&id=c5864ee6&scoped=true&"
import script from "./FeedbackDialog.vue?vue&type=script&lang=js&"
export * from "./FeedbackDialog.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackDialog.vue?vue&type=style&index=0&id=c5864ee6&prod&lang=scss&"
import style1 from "./FeedbackDialog.vue?vue&type=style&index=1&id=c5864ee6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5864ee6",
  null
  
)

export default component.exports